import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/comics";

export default function FaqPreview() {
  const items = faqItems.slice(0, 4);
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-question-answer-fill"></i>常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">追更疑问，一次说清</h2>
          </div>
          <Link
            to="/faq"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            全部问答 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          {items.map((item, idx) => (
            <details
              key={idx}
              className="group rounded-2xl bg-background-50 border border-background-200 p-4 md:p-5"
            >
              <summary className="flex items-center justify-between gap-3 cursor-pointer list-none text-sm md:text-base font-medium text-foreground-900">
                {item.q}
                <span className="shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}